import { AutogenModelConveyanceCode, AutogenRowConveyanceCode } from "./autogen/AutogenModelConveyanceCode";

export class ModelConveyanceCode extends AutogenModelConveyanceCode<RowConveyanceCode> {
	constructor() {
		super(RowConveyanceCode);
	}
}

export class RowConveyanceCode extends AutogenRowConveyanceCode {
}